import DOMPurify from 'dompurify';

// Both payloads carry user-entered data (pivot cell values, chart labels) and are
// injected as markup, so sanitize before they ever become DOM. The exported
// template is rendered by the backend exporter's browser, so anything scriptable
// that survives here would execute there.
function sanitizeTableHtml(markup) {
  return DOMPurify.sanitize(markup, { USE_PROFILES: { html: true } });
}

function sanitizeSvg(markup) {
  return DOMPurify.sanitize(markup, { USE_PROFILES: { svg: true, svgFilters: true } });
}

// getSVGString serializes the live chart node, which carries the on-screen pixel
// width/height and no viewBox. Narrowing that in CSS clips the drawing instead of
// scaling it, so derive a viewBox and drop the fixed size.
function makeSvgScalable(svg_markup) {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = sanitizeSvg(svg_markup);

  const svg = wrapper.querySelector('svg');
  if (!svg)
    return wrapper.innerHTML;

  const width = Number.parseFloat(svg.getAttribute('width'));
  const height = Number.parseFloat(svg.getAttribute('height'));

  if (!svg.getAttribute('viewBox') && width && height)
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);

  if (svg.getAttribute('viewBox')) {
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    svg.removeAttribute('width');
    svg.removeAttribute('height');
  }

  return wrapper.innerHTML;
}

function createPivotTable(chart) {
  const chart_container = chart.dataSource.table_html;
  const body = sanitizeTableHtml(chart_container.split('<body>')[1].split('</body>')[0]);

  const div = document.createElement('div');
  div.classList.add('pivot-table');

  // Flexmonster's HTML export covers the grid only. When the widget is showing a
  // chart it arrives separately as SVG, and sits beside the grid to mirror the
  // 50/50 split on the dashboard.
  if (chart.dataSource.chart_svg) {
    const grid = document.createElement('div');
    grid.classList.add('pivot-table__grid');
    grid.innerHTML = body;

    const chart_div = document.createElement('div');
    chart_div.classList.add('pivot-table__chart');
    chart_div.innerHTML = makeSvgScalable(chart.dataSource.chart_svg);

    const layout = document.createElement('div');
    layout.classList.add('pivot-table__layout');
    layout.append(grid, chart_div);
    div.appendChild(layout);
  }
  else {
    div.innerHTML = body;
  }

  return div;
}

export { createPivotTable };
